<template>
    <v-dialog v-model="dialog" max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="text-lowercase" 
                dark small v-on="on">
                add channel
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                New chanel parameters by <span class="secondary--text">{{ set.item }}</span> set
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent>
                        <v-row>
                            <v-col cols="12" md="4" sm="6">
                                <v-select dense v-model="team"
                                    return-object 
                                    :items="teams" 
                                    item-text="name"
                                    item-value="id"
                                    item-color="secondary" 
                                    label="team" 
                                    @change="onceMore()"
                                    :rules="[rules.required]">
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-select dense 
                                    v-model.number="type" 
                                    :items="types" 
                                    item-text="text"
                                    item-value="value"
                                    item-color="secondary" 
                                    label="type of channel" 
                                    @change="onceMore()"
                                    :rules="[rules.required]">
                                </v-select>
                            </v-col>
                            
                            <v-col cols="12" md="8" sm="6">
                                <v-select dense 
                                    v-model="trademark" 
                                    :items="filteredTrademarks" 
                                    item-text="name" multiple
                                    color="secondary" 
                                    item-color="secondary" 
                                    label="trademarks (multiple)" 
                                    @change="onceMore()"
                                    :rules="[rules.required]">
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="4" sm="6">
                                <v-text-field dense 
                                    color="secondary" label="stores" 
                                    v-model.number="stores"
                                    name="stores" 
                                    type="text" 
                                    :readonly="readonly" 
                                    :rules="[rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="8">
                                <v-text-field dense color="secondary" 
                                    label="channel name" 
                                    v-model="name"
                                    name="name"
                                    type="text" readonly>
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row v-if="error" justify="center" class="mx-2 error--text">! {{ error }}</v-row>
                <v-row justify="center" class="text-center mx-2">{{ message }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" :disabled="!valid || Boolean(error)"
                    @click="addChannel">Save</v-btn>
            </v-card-actions>
        </v-card>
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-dialog>
</template>

<script>
import Loader from '../../../layouts/Loader.vue'
import { retailInvestments, operationalCosts, getCoverage } from '../../../functions/retail';
export default {
    props: ['set', 'round'],
    data() {
        return {
            dialog: false,
            valid: false,
            message: '',
            error: '',
            calculating: false,
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'
            },
            types: [
                { text: 'online store', value: 1 },
                { text: 'team brick&mortar store', value: 2 },
                { text: 'trademark brick&mortar store', value: 3 },
            ],
            stores: 1,
            type: 1,
            team: null,
            trademark: []
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
        teams() {
            return this.$store.getters.teams;
        },
        trademarks() {
            return this.$store.getters.trademarks;
        },
        readonly() {
            if (this.type == 1) return true
            return false
        },
        filteredTrademarks() {
            if (this.team){
                const arr = [];
                this.team?.products.map(prod => {
                    const inArr = arr.find(it => it === prod.trademarkId)
                    if (!inArr) {
                        arr.push(prod.trademarkId)
                    }
                })
                const res = this.trademarks.filter(it => arr.indexOf(it.id) !== -1)
                return res
            }
            return this.trademarks
        },
        name() {
            let name = ''
			if (this.team && this.type && this.trademark?.length) {
				switch (this.type) {
					case 1: name = this.team.name.split('_')[0] + ' online';
						break;
					case 2: name = this.team.name.split('_')[0] + ' store';
						break;
					case 3: name = this.trademark + ' store';
				}
			}
			return name;
        }
    },
    watch: {
        team() {
            if (this.type === 1 || this.type === 2) {
                this.trademark = this.filteredTrademarks.map(item => item.name);
            }
            else if (this.filteredTrademarks.length === 1) {
                this.trademark = this.filteredTrademarks.map(item => item.name);
            }
        },
        async set() {
            try {
                await this.$store.dispatch('fetchTeams', Number(this.set.value));
            }
            catch (error) {
                await this.$store.dispatch('setError', error.message)
            }
        }
    },
    methods: {
        onceMore() {
            this.calculating = false;
            this.message = '';
            this.error = '';
            //this.trademark = []
        },
        async addChannel() {
            if (this.$refs.form.validate()) {
                //all brands plus
                if (this.type == 1 || this.type == 2) {
                    if (this.trademark.length !== this.filteredTrademarks.length) {
                        return this.error = `You must add all trademarks of the team ${this.team.name}!`
                    }
                }
                else if (this.type == 3) {
                    if (this.trademark.length !== 1) {
                        return this.error = `You can choose one of the team ${this.team.name} trademarks!`
                    }
                }

                const investments = retailInvestments(this.type, this.stores);
				const operational = operationalCosts(this.type, this.stores);
				const peak_market_coverage = getCoverage(this.type);

                const chan = {
                    gameId: Number(this.set.value),
                    round: Number(this.round),
                    register_round: Number(this.round),
                    teamId: this.team.id,
                    name: this.name,
                    stores: this.stores,
                    type: this.type,
                    investment_costs: investments,
                    operational_costs: operational,
                    peak_market_coverage: peak_market_coverage,
                    trademarks: this.trademark,
                    team: this.team
                }
                /*console.log(chan)*/
                await this.$store.dispatch('addAllChannel', chan)
                this.closeDialog();
            }
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.calculating = false;
            this.message = '';
            this.error = '';
            this.stores = 1;
            this.type = 1;
            this.trademark = [];

        }
    },
    components: { Loader },
    async mounted() {
        if (this.trademarks.length < 1) {
            try {
                await this.$store.dispatch('fetchTrademarks');
            }
            catch (error) {
                await this.$store.dispatch('setError', error.message)
            }
        }
        if (this.teams.length < 1) {
            try {
                await this.$store.dispatch('fetchTeams', this.set.value);
            }
            catch (error) {
                await this.$store.dispatch('setError', error.message)
            }
        }
    }
}
</script>
